import { useState, useEffect } from 'react';
import api from '../../api';

export default function ColourPicker({ value, onChange }) {
  const [colours, setColours]     = useState([]);
  const [showAdd, setShowAdd]     = useState(false);
  const [newName, setNewName]     = useState('');
  const [newHex, setNewHex]       = useState('#000000');
  const [saving, setSaving]       = useState(false);

  useEffect(() => {
    api.get('/api/v1/colours').then(r => setColours(r.data));
  }, []);

  function addColour() {
    if (!newName) return;
    setSaving(true);
    api.post('/api/v1/colours', { name: newName, hex: newHex })
      .then(r => {
        setColours(c => [...c, r.data]);
        onChange(r.data.name);
        setShowAdd(false);
        setNewName('');
        setSaving(false);
      })
      .catch(() => setSaving(false));
  }

  const selected = colours.find(c => c.name === value);

  return (
    <div>
      {/* Selected colour display */}
      <div style={s.selectedRow}>
        {value ? (
          <div style={s.selectedTag}>
            <div style={{ ...s.dot, background: selected?.hex || '#808080' }} />
            <span>{value}</span>
            <button style={s.clearBtn} onClick={() => onChange('')}>×</button>
          </div>
        ) : (
          <span style={s.placeholder}>No colour selected</span>
        )}
      </div>

      {/* Colour swatches */}
      <div style={s.swatches}>
        {colours.map(c => (
          <div key={c.id}
            onClick={() => onChange(c.name === value ? '' : c.name)}
            title={c.name}
            style={{
              ...s.swatch,
              background: c.hex,
              border: c.name === value ? '3px solid #14b8a6' : '2px solid #2a3040',
              transform: c.name === value ? 'scale(1.2)' : 'scale(1)',
            }}
          />
        ))}
        {/* Add custom colour */}
        <div style={s.addSwatch} onClick={() => setShowAdd(v => !v)} title="Add custom colour">
          <span style={{ fontSize: '16px', color: '#6b7280' }}>+</span>
        </div>
      </div>

      {/* Add custom colour form */}
      {showAdd && (
        <div style={s.addForm}>
          <input
            style={s.nameInput}
            placeholder="Colour name..."
            value={newName}
            onChange={e => setNewName(e.target.value)}
          />
          <input
            type="color"
            value={newHex}
            onChange={e => setNewHex(e.target.value)}
            style={s.colorInput}
          />
          <button style={s.addBtn} disabled={saving} onClick={addColour}>
            {saving ? '...' : 'Add'}
          </button>
          <button style={s.cancelBtn} onClick={() => setShowAdd(false)}>Cancel</button>
        </div>
      )}
    </div>
  );
}

const s = {
  selectedRow:  { marginBottom: '8px', minHeight: '24px' },
  selectedTag:  { display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#1e2329', border: '1px solid #2a3040', borderRadius: '6px', padding: '4px 8px', fontSize: '12px' },
  dot:          { width: '12px', height: '12px', borderRadius: '50%', border: '1px solid rgba(255,255,255,0.2)', flexShrink: 0 },
  clearBtn:     { background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: '16px', lineHeight: 1, padding: '0 2px' },
  placeholder:  { fontSize: '12px', color: '#4b5563' },
  swatches:     { display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' },
  swatch:       { width: '24px', height: '24px', borderRadius: '50%', cursor: 'pointer', transition: 'transform 0.15s, border 0.15s', flexShrink: 0 },
  addSwatch:    { width: '24px', height: '24px', borderRadius: '50%', border: '1px dashed #2a3040', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
  addForm:      { display: 'flex', gap: '6px', alignItems: 'center', marginTop: '8px', flexWrap: 'wrap' },
  nameInput:    { background: '#0f1117', border: '1px solid #2a3040', borderRadius: '6px', color: '#f0f2f5', padding: '6px 8px', fontSize: '12px', flex: 1, minWidth: '120px' },
  colorInput:   { width: '36px', height: '32px', border: '1px solid #2a3040', borderRadius: '6px', cursor: 'pointer', background: 'none', padding: '2px' },
  addBtn:       { background: '#14b8a6', color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' },
  cancelBtn:    { background: 'none', border: '1px solid #2a3040', color: '#6b7280', borderRadius: '6px', padding: '6px 10px', fontSize: '12px', cursor: 'pointer' },
};